namespace RioERP.Users {
    export interface CustomerAddressForm {
        CustomerId: Serenity.LookupEditor;
        Address1: Serenity.StringEditor;
        Address2: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Country: Serenity.StringEditor;
        PinCode: Serenity.StringEditor;
    }

    export class CustomerAddressForm extends Serenity.PrefixedContext {
        static formKey = 'Users.CustomerAddress';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CustomerAddressForm.init)  {
                CustomerAddressForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CustomerAddressForm, [
                    'CustomerId', w0,
                    'Address1', w1,
                    'Address2', w1,
                    'City', w1,
                    'StateId', w0,
                    'Country', w1,
                    'PinCode', w1
                ]);
            }
        }
    }
}
